import { axInstBasic } from "../Service/Service";

export const getArnPayload = (arnKey, arnValue) => {
  return { [arnKey]: arnValue };
};

// 1
export const getVehicleCount = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}vehicleCount`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 2
export const getTotalDistTravel = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}totalDistTravel`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 3
export const getDistCoveredPerMonthPerVin = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}distCoveredPerMonthPerVin`,
    getArnPayload(arnKey, arnValue)
  );
  const val =
    res.data.result.A_Total_Distance_KM.value /
    res.data.result.B_Month_count.value;
  return val;
};

// 4
export const getTotalHrEngineOn = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getTotalHrEngineOn`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 5
export const getEngineHoursOnPerMonthVin = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getEngineHoursOnPerMonthVin`,
    getArnPayload(arnKey, arnValue)
  );
  const val =
    res.data.result.A_Engine_Runtime_Hrs.value /
    res.data.result.B_Month_count.value;
  return val;
};

// 6
export const getAvgFuelConsumedInKmplLitHour = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getAvgFuelConsumedInKmplLitHour`,
    getArnPayload(arnKey, arnValue)
  );

  const val = res.data.result.B_Fuel_Consumed_L.value
  const feKmPl = res.data.result.A_Total_Distance_KM.value / res.data.result.B_Fuel_Consumed_L.value
  return {val, feKmPl}
};

// 7
export const getFuelConsumedInKmplLtrHour = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getFuelConsumedInKmplLtrHour`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 8
export const getMedianFuelConsumedKmpl = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getMedianFuelConsumedKmpl`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 9
export const getTotalFuelLostLit = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getTotalFuelLostLit`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 10
export const getEngineRuntimeHrsDays = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getEngineRuntimeHrsDays`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};
// 11
export const getEngineRuntimeHrsMonth = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getEngineRuntimeHrsMonth`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 12
export const getTotalDistMonth = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getTotalDistMonth`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

//   13
export const getTotalDistDays = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getTotalDistDays`,
    getArnPayload(arnKey, arnValue)
  );
  return res.data.result;
};

// 14
export const getAvgDistCoveredPerDayPerVin = async (arnKey, arnValue) => {
  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}getAvgDistCoveredPerDayPerVin`,
    getArnPayload(arnKey, arnValue)
  );
  const val = (res.data.result.A_Total_Distance_KM.value / res.data.result.B_day_count.value).toFixed(2)
  return val;
};